"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textComparisonHandler = void 0;
var textComparisonHandler = function (resultValue, filterValues) {
    if (typeof resultValue !== "string" || typeof filterValues !== "string") {
        return false;
    }
    return resultValue.includes(filterValues);
};
exports.textComparisonHandler = textComparisonHandler;
//# sourceMappingURL=textComparisonHandler.js.map